import {
    CONSULTAR_MAESTRO_UEN,
    MAESTRO_UEN_CONSULTADO,
    maestroUenConsultado,
    errorConsultadoMaestroUen,
    CONSULTAR_MAESTRO_TRANSACCIONES_SAT,
    MAESTRO_TRANSACCIONES_SAT_CONSULTADO,
    maestroTransaccionesSatConsultado,
    errorConsultadoMaestroTransaccionesSat,
    CONSULTAR_CATALOGO_GLOSAS_SAT,
    catalogoGlosasSatConsultado,
    errorConsultandoCatalogoGlosasSat,
    CATALOGO_GLOSAS_SAT_CONSULTADO,
    errorConsultadoServiciosReciboSat,
    serviciosReciboSatConsultado,
    CONSULTAR_SERVICIOS_RECIBO_SAT,
    SERVICIOS_RECIBO_SAT_CONSULTADO
} from "./maestrosActions";
import { authenticatedAjax } from "src/co/sura/config/ajax-wrapper";
import { AnyAction } from "redux";
import { TIPO_CONSULTA } from "../../sat/config_servicios/modelo/TipoConsulta";
import { TransaccionSat } from "../modelo/TransaccionSat";

export const consultarMaestroUenEpic = action$ =>
    action$.ofType(CONSULTAR_MAESTRO_UEN)
        .mergeMap((action) => {
            return authenticatedAjax
                .get(
                    "maestros/uen"
                )
                .map((response) => {
                    const uenActivas = JSON.parse(response.response);
                    return maestroUenConsultado(uenActivas);
                })
                .catch(_ => {
                    return [errorConsultadoMaestroUen()];
                });
        });

export const consultarMaestroTransaccionesSatEpic = action$ =>
    action$.ofType(CONSULTAR_MAESTRO_TRANSACCIONES_SAT)
        .mergeMap((action) => {
            const url = `sat/consultar/servicios?tipoConsulta=${TIPO_CONSULTA.CONSULTA_SELECTOR}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    return maestroTransaccionesSatConsultado(convertirRespuestaServicio(response));
                })
                .catch(_ => {
                    return [errorConsultadoMaestroTransaccionesSat()];
                });
        });

export const consultarServiciosReciboSatEpic = action$ =>
        action$.ofType(CONSULTAR_SERVICIOS_RECIBO_SAT)
            .mergeMap((action) => {
                const url = `sat/consultar/servicios?tipoConsulta=${TIPO_CONSULTA.CONSULTA_SELECTOR_CON_PARAMETRO}&parametro=SERVICIOS_RECIBO_SAT`;
    
                return authenticatedAjax
                    .get(
                        url
                    )
                    .map((response) => {
                        return serviciosReciboSatConsultado(convertirRespuestaServicio(response));
                    })
                    .catch(_ => {
                        return [errorConsultadoServiciosReciboSat()];
                    });
            });

export const consultarCatalogoGlosasSatEpic = action$ =>
    action$.ofType(CONSULTAR_CATALOGO_GLOSAS_SAT)
        .mergeMap((action) => {
            return authenticatedAjax
                .get(
                    "maestros/catalogoglosassat"
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return catalogoGlosasSatConsultado(respuesta.datos);
                })
                .catch(_ => {
                    return [errorConsultandoCatalogoGlosasSat()];
                });
        });

export const maestrosReducer = (state = {
    uenActivas: [],
    transaccionesSat: [],
    catalogoGlosasSat: []
}, action: AnyAction) => {
    switch (action.type) {
        case CONSULTAR_MAESTRO_UEN:
            return { ...state, uenActivas: [] };
        case MAESTRO_UEN_CONSULTADO:
            return { ...state, uenActivas: action.uenActivas };
        case CONSULTAR_MAESTRO_TRANSACCIONES_SAT:
            return { ...state, transaccionesSat: [] };
        case MAESTRO_TRANSACCIONES_SAT_CONSULTADO:
            return { ...state, transaccionesSat: action.transaccionesSat };
        case CONSULTAR_CATALOGO_GLOSAS_SAT:
            return { ...state, catalogoGlosasSat: [] };
        case CATALOGO_GLOSAS_SAT_CONSULTADO:
            return { ...state, catalogoGlosasSat: action.catalogoGlosasSat };
        case CONSULTAR_SERVICIOS_RECIBO_SAT:
            return { ...state, serviciosReciboSat: []};
        case SERVICIOS_RECIBO_SAT_CONSULTADO:
            return { ...state, serviciosReciboSat: action.serviciosReciboSat };
        default:
            return state;
    }
};

const convertirRespuestaServicio = (respuesta: any) => {
    return JSON.parse(respuesta.response).datosEntidad
        .sort((a, b) => a.consecutivo - b.consecutivo)
        .map(servicio => {
            const tipo: TransaccionSat = {
                codigo: servicio.consecutivo,
                nombre: servicio.textoSelector,
                esGestionable: servicio.snGestionable,
                tablaTraza: servicio.tablaTraza
            };
            return tipo;
        });
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/modulos/maestrosReducers.tsx